import { Utils } from "utils";
import { RootState } from "store/store";

export const selectIsMemberAuthed = (state: RootState) =>
  state.routeAuthState.data.isAuthed;

export const selectCurrentMember = (state: RootState) =>
  state.routeAuthState.data.member;

export const selectIsMemberSupporter = (state: RootState) => {
  const member = state.routeAuthState.data.member;
  return Utils.Member.isActive(member);
};
